import api from "../api/axios";

const url = `employees`;

export const getCompanyWorkTimings = async (company_id) => {
  try {
    const response = await api.get(
      `${url}/working/timing?company_id=${company_id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching company work timing:", error);
    throw error;
  }
};

export const getWorkLocationTypes = async () => {
  try {
    const response = await api.get(`${url}/working/location-type`);
    return response.data;
  } catch (error) {
    console.error("Error fetching work location types:", error);
    throw error;
  }
};

export const getEmployeesRole = async () => {
  try {
    const response = await api.get(`${url}/profile/role`);
    return response.data;
  } catch (error) {
    console.error("Error fetching role types:", error);
    throw error;
  }
};

export const generateEmploymentId = async (
  companyName,
  departmentName,
  designationName,
  departmentId,
  designationId
) => {
  try {
    const response = await api.post(`${url}/generate/employment-id`, {
      companyName,
      departmentName,
      designationName,
      departmentId,
      designationId,
    });
    return response.data;
  } catch (error) {
    console.error("Error getting employment id:", error);
    throw error;
  }
};

export const fetchCompanyEmployees = async (
  company_id,
  params = { status: 1 }
) => {
  try {
    const response = await api.get(`employees/employeeDetails/${company_id}`, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching company employees:", error);
    throw error;
  }
};

export const assignDepartment = async (data) => {
  try {
    const response = await api.post(
      `hr-department-assignment/assign-department`,
      data
    );
    return response.data;
  } catch (error) {
    console.error("Error assigning department:", error);
    throw error;
  }
};

export const getAssignedDepartment = async (company_id) => {
  try {
    const response = await api.get(`hr-department-assignment/${company_id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching department assignment:", error);
    throw error;
  }
};

export const getEmployeeDetails = async (employeeId) => {
  try {
    const response = await api.get(`employees/employee_details/${employeeId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching employee details:", error);
    throw error;
  }
};

export const fetchPendingEmployeeRequests = async (params = {}) => {
  try {
    const response = await api.get(`/api/v1/employees/pending-requests`, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching pending employee requests:", error);
    throw error;
  }
};

export const fetchEmployeePendingRequests = async (employeeId, params = {}) => {
  try {
    const response = await api.get(`/api/v1/employees/${employeeId}/pending-requests`, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching employee pending requests:", error);
    throw error;
  }
};

export const handleEmployeeRequestAction = async (payload) => {
  try {
    const response = await api.post(`/api/v1/employees/request-action`, payload);
    return response.data;
  } catch (error) {
    console.error("Error handling employee request action:", error);
    throw error;
  }
};
